import { useAuth0 } from '@auth0/auth0-react'
import { useTheme } from '@material-ui/core'
import queryString from 'query-string'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { AuthService } from './services/auth'

const Login = () => {
  const auth0 = useAuth0()
  const navigate = useNavigate()
  const theme = useTheme()
  const { email } = queryString.parse(window.location.search)
  const location = useLocation()

  useEffect(() => {
    const loginProcess = async () => {
      // eslint-disable-next-line
      if (AuthService.GetCurrent()) {
        await AuthService.GetCurrent().Logout()
      }

      const organizationId = localStorage.getItem('organizationId')
      let returnUrl = (location.state as { returnUrl: string })?.returnUrl

      if (!returnUrl) {
        returnUrl = organizationId ? '/app' : '/app/workspaces'
      }

      if (auth0.isAuthenticated && !auth0.isLoading) {
        navigate(returnUrl)
        return
      }

      await auth0.loginWithRedirect({
        display: 'page',
        appState: { returnUrl },
        login_hint: email && decodeURIComponent(email?.toString()),
        logo: theme.logoSrc,
        primaryColor: theme.palette.primary.main,
        page_background: theme.palette.background.default,
        backgroundImage: theme.backgroundImageSrc,
      })
    }

    loginProcess()
  })

  return <div />
}

export default Login
